module.exports = __webpack_public_path__ + "static/e1_large-7811e395ddbb5fcb5b020392961891fa.jpg";